import React from 'react';
import { Link } from 'react-router-dom';
import WhiteStyledButton from '../components/WhiteStyledButton';

const Navbar = () => {
  return (
    <nav className="flex justify-between items-center px-10 py-5 bg-white">
      <div className="flex items-center">
        <img 
          src="https://speargrowth.com/wp-content/themes/speargrowth/assets_new_2024/images/logo.svg" 
          alt="Logo"
          className="h-8 w-auto cursor-pointer"
          onClick={() => window.location.href = 'https://speargrowth.com/'}
        />
      </div>
      
      <WhiteStyledButton 
        onClick={() => window.location.href = 'https://speargrowth.com/'}
      >
        Back to Home Page →
      </WhiteStyledButton>
    </nav>
  );
};

export default Navbar;